export enum EHarvestSaleRoute {
  main = '/harvest-sale',
  lots = 'lots',
  cultureLots = '/harvest-sale/:cultureId/lots',
}
